import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for D5M4 (託工入庫單沖銷)
// ============================================================

export interface ReverseCandidate {
  fd140_01: string;  // 單號
  fd140_11: string;  // 入庫日期 (YYYY-MM-DD)
  fd140_12: string;  // 廠商代碼
  fd140_13: string;  // 廠商名稱
  fd140_16: string;  // 金額
  fd140_37: string;  // 工繳係數
  fd140_181: string; // 產品代號前段
  fd140_182: string; // 產品代號後段
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export function createD5M4Api(basePath = '/api/d5m4') {
  return {
  /** Query subcontract receipt candidates eligible for reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get(`${basePath}/candidates`, { params });
    return res.data;
  },

  /** Execute batch reversal for selected subcontract receipt records */
  async reverse(items: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post(`${basePath}/reverse`, { items, confirmed: true });
    return res.data;
  },
  };
}

export const d5m4Api = createD5M4Api();
export const d5n4Api = createD5M4Api('/api/d5n4');
